export const strings = {
  NAME: "Form",
  DESCRIPTION: "Collect information and save it in a data source.",
} as const;
